import React from 'react';

const CameraOffFillSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            className="camera-off-fill_svg__cls-1"
            fill="none"
            d="M8 13a4 4 0 0 0 6.21 3.33l-5.54-5.51A4 4 0 0 0 8 13zM16 13a4 4 0 0 0-4-4 3.94 3.94 0 0 0-1.84.45l5.39 5.39A3.94 3.94 0 0 0 16 13z"
        />
        <path
            className="camera-off-fill_svg__cls-2"
            d="M12 17a4 4 0 0 1-3.33-6.22L3.88 6H2v14h15.88l-3.67-3.67A4 4 0 0 1 12 17zM22 6h-6V4H8v2H6.71L6 5.33V4H5v.29L2.78 2.11l-.7.71L5 5.74l4.33 4.33L15 15.71 19.3 20l1.85 1.85.37-.38.33-.33L20.71 20H22zM10.16 9.49A3.94 3.94 0 0 1 12 9a4 4 0 0 1 4 4 3.94 3.94 0 0 1-.45 1.84z"
        />
    </svg>
);

CameraOffFillSvg.displayName = 'CameraOffFillSvg';
export default CameraOffFillSvg;
